import React, { useContext, useState } from 'react'
import ImageWithBasePath from './ImageWithBasePath'
import classNames from 'classnames'
import { SharedContext } from '../context/SharedContext'
export const UserSearchedComponent = ({keywords}) => {
  const { location } = useContext(SharedContext)
  const searchedItems = !keywords?.length > 0 ? [
    {
      title: `Part time job in ${location?.name || location?.title}`,
      path: '#'
    },
    {
      title: `Office jobs in ${location?.name || location?.title}`,
      path: '#'
    },
    {
      title: 'Work from home Data Entry jobs',
      path: '#'
    },
    {
      title: 'Part time Data Entry jobs',
      path: '#'
    },
    {
      title: `Driver Jobs in ${location?.name || location?.title}`,
      path: '#'
    },
    {
      title: `Driver Jobs in ${location?.name || location?.title}`,
      path: '#'
    },
    {
      title: `Office jobs in ${location?.name || location?.title}`,
      path: '#'
    },
    {
      title: 'Field Jobs',
      path: '#'
    },
    {
      title: 'Part time Data Entry jobs',
      path: '#'
    },
    {
      title: `Driver Jobs in ${location?.name || location?.title}`,
      path: '#'
    },
    {
      title: `Office jobs in ${location?.name || location?.title}`,
      path: '#'
    },
    {
      title: 'Part time Data Entry jobs',
      path: '#'
    },
    {
      title: `Driver Jobs in ${location?.name || location?.title}`,
      path: '#'
    },
    {
      title: `Office jobs in ${location?.name || location?.title}`,
      path: '#'
    }
  ] : keywords ;
  const [showAll, setShowAll] = useState(false)
  const visibleItems = showAll ? searchedItems : searchedItems.slice(0, 5)
  const toggleView = () => {
    setShowAll(!showAll)
  }
  return (
    <div className="rounded-sm border-[1px] border-solid border-[#E5E5E5] bg-[#FFF] py-[16px] px-[12px]">
      <div className="pb-[12px] font-noto-sans text-md font-bold leading-24 text-[#333436]">
        Users also searched for:
      </div>
      <div className="flex flex-wrap gap-x-2">
        {visibleItems.map((item, index) => (
          <div
            key={index}
            className={classNames(
              'flex w-fit items-center rounded-sm bg-[#F2F2F2] px-[12px] py-[6px]',
              index < visibleItems.length - 1 && 'mb-[12px]'
            )}
          >
            <div>
              <ImageWithBasePath src={'search_user'} height={16} width={16} alt="search" />
            </div>
            <div className="pl-[4px] font-noto-sans text-sm font-normal leading-16 text-[#4B4B4B]">
              {keywords?.length > 0 ? item : item?.title}
            </div>
          </div>
        ))}
      </div>
      {searchedItems.length > 5 && (
        <div
          className="flex w-fit cursor-pointer items-center gap-1.5 pt-[12px]"
          onClick={toggleView}
        >
          <div className="py-[6px] pl-[12px] font-noto-sans text-sm font-bold leading-16 text-[#0E56A8]">
            {showAll ? 'View less' : 'View all'}
          </div>
          {!showAll ? (
            <ImageWithBasePath src={'dropDownBlue'} height={14} width={14} alt="search" />
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={14}
              height={14}
              viewBox="0 0 14 14"
              fill="none"
            >
              <mask
                id="mask0_454_2144"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x={0}
                y={0}
                width={14}
                height={14}
              >
                <rect width={14} height={14} fill="#D9D9D9" />
              </mask>
              <g mask={'url(#mask0_454_2144)'}>
                <path
                  d="M3.90846 8.56032C3.80152 8.45337 3.74805 8.31726 3.74805 8.15199C3.74805 7.98671 3.80152 7.8506 3.90846 7.74365L6.5918 5.06032C6.65013 5.00199 6.71332 4.96067 6.78138 4.93636C6.84944 4.91206 6.92235 4.8999 7.00013 4.8999C7.07791 4.8999 7.15082 4.91206 7.21888 4.93636C7.28694 4.96067 7.35013 5.00199 7.40846 5.06032L10.1064 7.75824C10.2133 7.86518 10.2668 7.99643 10.2668 8.15199C10.2668 8.30754 10.2085 8.44365 10.0918 8.56032C9.98485 8.66726 9.84874 8.72074 9.68346 8.72074C9.51819 8.72074 9.38207 8.66726 9.27513 8.56032L7.00013 6.28532L4.71055 8.5749C4.6036 8.68185 4.47235 8.73532 4.3168 8.73532C4.16124 8.73532 4.02513 8.67699 3.90846 8.56032Z"
                  fill="#191919"
                />
              </g>
            </svg>
          )}
        </div>
      )}
    </div>
  )
}